
































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class SummaryCashflow extends Vue {
  @Prop() readonly doc!: any;
}
